import createActionType from '../core/createActionType';
import { NAME } from './constants';

export const AUTHORIZE_BY_APPLICATION = createActionType(`${NAME}/AUTHORIZE_BY_APPLICATION`);